<template>
  <div>
      <v-app-bar class="white">
         <router-link to="/" tag="card">
       <img class="ml-5" :src="require('../assets/operationwise_logo.png')" height="40"/>
       </router-link>
       <v-spacer />
         <v-btn text to="">Login</v-btn>
         <v-btn text>Signup</v-btn>
         <v-btn text to="/c/dashboard" large dark class="text-capitalize orange  ma-5">Try the App</v-btn>
      </v-app-bar>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>